import { Period1acEnum, RisksEnum } from '@insurance/api/requests'
import { BooleanRadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Checkbox, Col, Divider, Form, Row, Select, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCmrInsuranceValues } from './CmrInsuranceContext'
import { TariffAmountFields } from './TariffAmountFields'
import { formProps } from './utils'
import { ValidFrom } from './ValidFrom'

const { Title } = Typography

export const CoverageItems = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { isEditable } = useCmrInsuranceValues()
  const formInstance = Form.useFormInstance()

  const {
    periodProps,
    generalCargoProps,
    highRiskCargoProps,
    risksProps,
    employeeErrorsProps,
    additionalExpensesProps
  } = formProps(t)

  const periodOptions = [
    { label: t('m1'), value: Period1acEnum._1 },
    { label: t('m12'), value: Period1acEnum._12 }
  ]

  const riskOptions = Object.values(RisksEnum).map((value) => ({
    label: t(value),
    value
  }))

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col xs={24} lg={12}>
          <ValidFrom />
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item {...periodProps} rules={[required]}>
            <Select
              placeholder={periodProps.label}
              options={periodOptions}
              disabled={isEditable}
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider />

      <Title level={5}>{t('coverage_types')}</Title>

      <Form.Item {...generalCargoProps} rules={[required]}>
        <BooleanRadioCardGroup
          onChange={(e) =>
            formInstance.setFieldValue(highRiskCargoProps.name, !e.target.value)
          }
        />
      </Form.Item>

      <Form.Item {...highRiskCargoProps} rules={[required]}>
        <BooleanRadioCardGroup
          onChange={(e) =>
            formInstance.setFieldValue(generalCargoProps.name, !e.target.value)
          }
        />
      </Form.Item>

      <Form.Item {...risksProps} label={t('risks')}>
        <Checkbox.Group options={riskOptions} />
      </Form.Item>

      <Form.Item {...employeeErrorsProps} rules={[required]}>
        <BooleanRadioCardGroup />
      </Form.Item>

      <Form.Item {...additionalExpensesProps} rules={[required]}>
        <BooleanRadioCardGroup />
      </Form.Item>

      <Divider />

      <TariffAmountFields />
    </>
  )
}
